import {
  getSupportTicketFailure,
  getSupportTicketLoading,
  getSupportTicketSuccess,
  updateSupportTicketFailure,
  updateSupportTicketLoading,
  updateSupportTicketSuccess,
} from "@redux/slices/ticketSlice";
import { getSupportTicket } from "@services/ticket/getSupportTicket";
import { updateSupportTicket } from "@services/ticket/updateSupportTicket";
import { useDispatch } from "react-redux";
import getErrorStatement from "src/utils/getErrorStatement";
import { notify } from "src/utils/notify";

const useTicket = () => {
  const dispatch = useDispatch();

  const handleGetSupportTicket = async (searchFilters) => {
    try {
      dispatch(getSupportTicketLoading());
      const response = await getSupportTicket(searchFilters);
      dispatch(getSupportTicketSuccess(response.data));
    } catch (error) {
      dispatch(getSupportTicketFailure());
      notify(getErrorStatement(error));
    }
  };

  const handleUpdateSupportTicket = async (updatedData) => {
    try {
      dispatch(updateSupportTicketLoading());
      const response = await updateSupportTicket(updatedData);
      dispatch(updateSupportTicketSuccess(response.data));
      notify("Support Ticket details updated successfully", "success");
    //   handleGetDoctorById(updatedData?.local?.email);
    } catch (error) {
      dispatch(updateSupportTicketFailure());
      notify(getErrorStatement(error));
    }
  };

  return {
    handleGetSupportTicket,
    handleUpdateSupportTicket,
  };
};

export default useTicket;
